// extracted by mini-css-extract-plugin
export default {"container":"pageloader_container__Bg9Eo","lottieContainer":"pageloader_lottieContainer__Sa7fy"};